import { useRouter } from 'next/router'
import { VFC } from 'react'
import { deleteTag, renameTag } from 'src/api/companyMessageRoomTag'
import { useMessageContext } from 'src/compositions/Messages/MessageContext'
import { ReportModal } from 'src/compositions/Messages/Modals/ReportModal'
import {
  convertMessagePageQuqry,
  convertTagIds,
  stringifyQueryToComma,
  toMessagePageQuery,
} from 'src/utils/routes'
import { RenameOrDeleteTagModal } from './RenameOrDeleteTagModal'
import { TagValidationModal } from './TagValidationModal'

type ModalsProps = {
  mutates: () => void
}
export const Modals: VFC<ModalsProps> = ({ mutates }) => {
  const {
    room,
    isReportModalOpen,
    setReportModalOpen,
    editTagId,
    setEditTagId,
    isDeleteTagModalOpen,
    setIsDeleteTagModalOpen,
    editTagName,
    isRenameTagModalOpen,
    setIsRenameTagModalOpen,
    tagValidationMessage,
    isTagValidationModalOpen,
    setIsTagValidationModalOpen,
  } = useMessageContext()
  const router = useRouter()
  const query = convertMessagePageQuqry(router.query)
  const tagIds = convertTagIds(query.tag_ids)

  const onSubmitRename = async () => {
    editTagId && (await renameTag(editTagId, editTagName))
    mutates()
    setEditTagId(undefined)
  }
  const onSubmitDelete = async () => {
    editTagId && (await deleteTag(editTagId))
    mutates()
    router.push(
      toMessagePageQuery({
        pathname: router.pathname,
        query: {
          ...query,
          tag_ids: stringifyQueryToComma({
            tag_ids: tagIds.filter((id) => id !== editTagId),
          }),
        },
      }),
    )
  }

  return (
    <>
      {isReportModalOpen && (
        <ReportModal
          counterId={room ? room.counters[0].id : undefined}
          close={() => setReportModalOpen(false)}
        />
      )}
      {isRenameTagModalOpen && (
        <RenameOrDeleteTagModal
          close={() => setIsRenameTagModalOpen(false)}
          typeText="編集"
          submit={onSubmitRename}
        />
      )}
      {isDeleteTagModalOpen && (
        <RenameOrDeleteTagModal
          close={() => setIsDeleteTagModalOpen(false)}
          typeText="削除"
          submit={onSubmitDelete}
        />
      )}
      {isTagValidationModalOpen && (
        <TagValidationModal
          message={tagValidationMessage}
          close={() => setIsTagValidationModalOpen(false)}
        />
      )}
    </>
  )
}
